import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

const TickListModal = ({ open, onClose, p }) => {
  if (!p) {
    return null;
  }

  return (
    <Dialog open={open} onClose={() => onClose(p)} aria-labelledby="form-dialog-tick-list">
      <DialogTitle id="form-dialog-tick-list">Tick list</DialogTitle>
      <DialogContent>
      <List dense={true}>
        {p.ticks && p.ticks.map((t, index) => {
          let stars = "\u2606\u2606\u2606";
          if (t.stars===1.0) stars = "\u2605\u2606\u2606";
          else if (t.stars===2.0) stars = "\u2605\u2605\u2606";
          else if (t.stars===3.0) stars = "\u2605\u2605\u2605";

          let txt = stars + " " + t.name;
          if (t.grade) {
            txt += " (" + t.created + ", " + t.grade + ")"
          } else {
            txt += " (" + t.created + ")"
          }
          return (
            <ListItem key={index}>
              <ListItemText primary={txt}/>
            </ListItem>
          );
        })}
      </List>
      </DialogContent>
    </Dialog>
  );
}

export default TickListModal;